<template>
    <SideHeader :indexPage="true"/>
    <div id="appCapsule">

        <div class="section full mt-2 mb-2">
            <div class="section-title">تاریخچه شکایت و انتقادات</div>
            <div class="wide-block pt-2 pb-2">

                <!-- comment block -->
                <div class="comment-block">
                    <!--item -->
                    <div class="item" v-for="complaint in complaints" :key="complaint.id">
                        <div class="avatar">
                            <img src="assets/img/sample/avatar/Untitled-1.png" alt="avatar" class="imaged w32 rounded">
                        </div>
                        <div class="in">
                            <div class="comment-header">
                                <h4 class="title">{{ complaint.title }}</h4>
                                <!-- <span class="time">{{ message.trackingCode }}</span> -->
                            </div>
                            <div class="text">
                                {{ complaint.message }}
                            </div>
                            <div class="message-item">
                                <img src="assets/img/logo.png" alt="avatar" class="avatar">
                                <div class="content">
                                    <div class="title">پشتیبانی</div>
                                    <div class="bubble">
                                        {{ complaint.adminMessage == null ? 'در انتظار پاسخ پشتیبانی' : complaint.adminMessage }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- * item -->
                </div>
                <!-- * comment block -->
            </div>
        </div>
    </div>
</template>

<script>
import SideHeader from '@/components/SideHeader.vue';
import delivery_methods from '@/delivery_methods';
import axios from 'axios';

export default {
    name: "FeedbackFollow",
    components:{
        SideHeader
    },
    data() {
        return {
            complaints: [],
            idUser: window.localStorage.getItem("idUser"),
        };
    },
    methods: {
        getDriverMessages() {
            this.loading = true
            axios.get(`${delivery_methods.BASE_URL}api/driver/getComplaintDriver/${this.idUser}`)
                .then((response) => {
                    console.log(response);
                    this.complaints = response.data;
                })
                .catch(function (res) {
                    // handle error 
                    // console.log(res);
                })
                .finally((res) => {
                    this.loading = false
                });
        }
    },
    mounted() {
        this.getDriverMessages();
    }
}
</script>

<style scoped></style>